export const HEADINGS = [
  ["deposit_date", "Deposit Date"],
  ["bank_name", "Bank Name"],
  ["deposit_value", "Amount / Current"],
  ["account_name", "Account Name"],
  ["deposit_description", "Deposit Description"],
  ["status", "Status"],
  ["match", "Match"],
];
